import * as React from "react"

import bem from "../../../../bem"
import env from "../../../../env"
import { IBreadcrumbInfo } from "../../index"

interface Props {
    breadcrumbInfo: IBreadcrumbInfo
}

const b = bem.with("NewUI__breadcrumb")

export const Breadcrumb = ({
    breadcrumbInfo: {
        breadcrumb: { name, url },
    },
}: Props): JSX.Element => (
    <div className={`${b()} NewUI-breadcrumbs__item label`}>
        {name && url && (
            <a
                href={env.applicationPath + url}
                data-ft-main={name.toLowerCase()}
                className="text-black max-w-truncate no-underline"
                title={name}
            >
                <span className="is-underline" data-ft-name>
                    {name}
                </span>
            </a>
        )}
        <span className="tw-mx-2">/</span>
    </div>
)

export default Breadcrumb
